module.exports = __webpack_public_path__ + "static/img/eyes.5c3fefbb.png";